import { PaginatedRequest } from '@/app/common/utils/pagination/types';

export type ConnectionStatus = 'connecting' | 'connected' | 'disconnected';

export interface Notice {
  id?: number;

  status: NoticeStatus;

  photo?: string;

  title: string;

  subtitle?: string;

  content: string;

  link?: string;

  userId: number;

  createdAt: Date;
}

export interface NoticeFindAllParams extends PaginatedRequest {
  status?: Array<NoticeStatus>;
}

export enum NoticeStatus {
  SENT = 'SENT',
  VIEW = 'VIEW',
  READ = 'READ',
}
